import React from 'react';
import { StyledDiv } from './platformsBanner.styles';
import { Section } from '../section/section.comp';
import Image from 'next/image';
import { CSSProperties } from 'styled-components';
import Link from 'next/link';
import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';

interface IPlatformsBannerProps {
    mode?: 'dark' | 'light';
    img?: string;
    alt?: string;
    title: string;
    text: string;
    style?: CSSProperties;
    buttonText?: string;
    buttonLink?: string;
    className?: string;
}

export const PlatformsBanner = ({ className='',buttonLink = '', buttonText = '', mode = 'light', img, alt = '', title, text, style }: IPlatformsBannerProps) => {
    return (
        <Section style={style}>
            <StyledDiv mode={mode} className={`${img ? '' : 'more-padding'} ${className}`}>
                <div className="text-wrapper">
                    <h3>{title}</h3>
                    <p>{text}</p>
                    {buttonText &&
                        <Link href={buttonLink}>
                            {buttonText}
                            <IoIosArrowForward className='icon' />
                        </Link>
                    }
                </div>
                {img &&
                    <Image src={img} alt={alt} width={500} height={380} />
                }
            </StyledDiv>
        </Section>
    );
};
